/**
 * @fileoverview DELETE handler for "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component".
 * Idempotent — 204 whether or not the component had a configured constraint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys } from "./constants";
import type { DeleteDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps } from "./types";

export const deleteDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys,
  ({
    appGroupId,
    dsaId,
    component,
  }: DeleteDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps): Promise<void> =>
    fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints/${component}`, "DELETE")
);
